import React, { useEffect, useState } from "react";
import ProductsTemplate from "./products.template";
import { getInventorySearchAPi } from "./products.component.service";
import { useNavigate, useParams } from "react-router-dom";
import { addToCart } from "../../reducers/cart.reducer";
import { saveCartItemsAPI } from "../../service/cart.service";
import { getProductPrice } from "../../utils/cart.utils";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const ProductsComponent = () => {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();
  const { partNumber } = useParams();
  const [activeTab, setActiveTab] = useState("Pattri");
  const { user } = useSelector((state) => state.app);
  const { cart } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

//   const onLoad = async () => {
//     const response = await getDataApi();
//     console.log({ response });

//     if (response.status) {
//       setProduct(response.data);
//     }
//   };
  const handleProduct = async () => {
    try {
      setLoading(true);
      const payload = { keyword: partNumber };
      // console.log({ payload });
      const response = await getInventorySearchAPi(payload);
      // console.log({ response });
      if (response.status) {
        setInventoryItems(response.data.result);
        setProduct(response.data);
      } else {
        setError(response.message || "Failed to fetch inventory items");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

    const handleAddToCart = async (product) => {
    // Check if user is logged in
    if (!user) {
      // Redirect to login page with a return URL
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }

    // Create a clean version of cart data with only necessary fields
    const cartData = cart.map((item) => {
      const selected_price = getProductPrice(item);
      return {
        product_id: item.id,
        part_number: item.part_number,
        name: item.name,
        description: item.description,
        brand: item.brand,
        model: item.model,
        category: item.category,
        sub_category: item.sub_category,
        price: item.price,
        image: item.image,
        required_qty: item.required_qty || 1,
        alternate_packaging: [],
        selected_price: selected_price,
        actual_price: selected_price,
        total_amount: selected_price * (item.required_qty || 1),
      };
    });

    try {
      // Save cart item to database
      const response = await saveCartItemsAPI({
        cart: cartData,
        customer_id: user.id,
      });

      if (response.status) {
        console.log("Item added to cart successfully", response.data);
        // Optionally update the local cart state if needed
      } else {
        console.error("Failed to add item to cart:", response.message);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
    }

    // Normalize price object if it's an array
    let priceObj = product.price;

    if (Array.isArray(product.price)) {
      const sortedSlabs = [...product.price].sort(
        (a, b) => parseInt(a.slab) - parseInt(b.slab)
      );

      priceObj = {
        min_order: parseInt(sortedSlabs[0]?.slab || 1),
        multiple: parseInt(sortedSlabs[0]?.slab || 1),
        price_list: sortedSlabs.map((slab) => ({
          min_qty: parseInt(slab.slab),
          price: parseFloat(slab.price),
        })),
      };
    }

    let requiredQty = product.required_qty || priceObj.min_order;
    let multiple = priceObj.multiple || 1;

    // Check if required quantity is greater than available quantity
    if (requiredQty > product.available_qty) {
      // Use partner's min and multiple quantities
      const partnerMinQty = parseInt(product.partner_min_qty) || 1;
      const partnerMulQty = parseInt(product.partner_mul_qty) || 1;

      // Calculate the minimum valid quantity based on partner's requirements
      const minValidQty = Math.max(
        partnerMinQty,
        Math.ceil(requiredQty / partnerMulQty) * partnerMulQty
      );

      // Update required quantity and multiple
      requiredQty = minValidQty;
      multiple = partnerMulQty;

      // Show a message to the user
      MySwal.fire({
        title: <strong>Quantity Adjusted</strong>,
        html: (
          <i>
            Your requested quantity exceeds available stock. Adjusted to{" "}
            {requiredQty} based on partner's minimum ({partnerMinQty}) and
            multiple ({partnerMulQty}) quantities.
          </i>
        ),
        icon: "info",
      });
    }
    // Validate quantity is a multiple of the defined multiple
    else if (requiredQty % multiple !== 0) {
      MySwal.fire({
        title: <strong>Invalid Quantity</strong>,
        html: <i>Please enter a quantity in multiples of {multiple}.</i>,
        icon: "warning",
      });
      return;
    }

    const cartProduct = {
      ...product,
      required_qty: requiredQty,
      manufacturer: product.make,
      price: priceObj,
    };

    console.log({ product, cartProduct });

    MySwal.fire({
      title: <strong>Cart Update!</strong>,
      html: <i>You've added {product.part_number} to your cart </i>,
      icon: "success",
    });

    dispatch(addToCart(cartProduct));
  };

  useEffect(() => {
    if (partNumber) 
      handleProduct();
  }, [partNumber]);

  // console.log({ inventoryItems, product });

  const templateData = {
    inventoryItems,
    loading,
    error,
    product,
    activeTab,
  };
  // console.log({templateData});

  const templateEvents = {
    handleProduct,
    handleTabClick,
    handleAddToCart,
  };
  return (
    <ProductsTemplate
      templateData={templateData}
      templateEvent={templateEvents}
    />
  );
};

export default ProductsComponent;
